<template>
  <div>
    <div class="mt-3">Solicitação Nº {{ idNotificacao }}</div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <b-button
          class="border shadow-sm mr-2"
          variant="light"
          v-b-tooltip.hover="'Voltar'"
          @click="voltar()"
        >
          <font-awesome-icon icon="chevron-left" size="lg" fixed-width />
          <span class="align-middle">Voltar</span>
        </b-button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsSolicitacoesInscricao"
          :orderby="sortBy"
          :items="lstSolicitacaoInscricao"
          responsive
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :mostrarQuantidade="false"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
    </div>
    <FccSolicitacaoStatus
      @statusManipula="statusManipula"
      :baseUrlPublicacao="baseUrlPublicacao"
      :controlePage="controlePage"
      :idNotificacao="idNotificacao"
    />
    <FccExecutaSolicitacoes
      v-if="statusExportacao"
      @exportarOk="exportarOk"
      :baseUrlPublicacao="baseUrlPublicacao"
      :controlePage="controlePage"
      :idNotificacao="idNotificacao"
    />

    <FccPublicarSolicitacoes
      v-if="statusPublicacao && statusExportacao && permissao != null"
      :baseUrlPublicacao="baseUrlPublicacao"
      :controlePage="controlePage"
      :idNotificacao="idNotificacao"
    />
  </div>
</template>
<script>
import axios from 'axios'
import FccSolicitacaoStatus from './fccSolicitacaoStatus.vue'
import FccExecutaSolicitacoes from './fccExecutaSolicitacoes.vue'
import FccPublicarSolicitacoes from './fccPublicarSolicitacoes.vue'

export default {
  data() {
    return {
      statusExportacao: false,
      statusPublicacao: false,
      permissao: null,
      titlePage: 'Publicações',
      sortBy: 'nome',
      itemPorPage: '1000',
      lstSolicitacaoInscricao: [],
      fieldsSolicitacoesInscricao: [
        { key: 'respondente', label: 'Respondente', sortable: true },
        { key: 'dataresposta', label: 'Data da Resposta', sortable: true },
        { key: 'aguardando', label: 'Aguardando', sortable: true },
        { key: 'statusfinal', label: 'Status' }
      ]
    }
  },
  methods: {
    voltar() {
      this.$emit('zerarSolicitacao', 0)
    },
    exportarOk(status) {
      this.statusPublicacao = status
    },
    statusManipula(status) {
      this.statusExportacao = status
    },
    listarCicloSolicitacaoInscricao() {
      axios
        .get(
          this.baseUrlPublicacao +
            'InscricoesDeferidasCanceladas/ListarCicloSolicitacaoInscricao/' +
            this.controlePage.spi +
            '/' +
            this.idNotificacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstSolicitacaoInscricao = response.data
          if (this.lstSolicitacaoInscricao.length > 0) {
            this.lstSolicitacaoInscricao.forEach(function (data) {
              data['statusfinal'] = data['status']
              delete data['status']
            })
          }
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object,
    idNotificacao: Number,
    baseUrlPublicacao: String
  },
  components: {
    FccSolicitacaoStatus,
    FccExecutaSolicitacoes,
    FccPublicarSolicitacoes
  },
  mounted() {
    this.permissao = this.permissaoPage.find((lista) => lista.objpermcodigo === 'X')
    this.listarCicloSolicitacaoInscricao()
  }
}
</script>
